export const state = {
  cancelTokens: []
};

export const getters = {
  cancelTokens(state) {
    return state.cancelTokens;
  }
};

export const mutations = {
  ADD_CANCEL_TOKEN(state, token) {
    state.cancelTokens.push(token);
  },
  CLEAR_CANCEL_TOKENS(state) {
    state.cancelTokens = [];
  }
};

export const actions = {
  cancelPendingTokens(context) {
    // Cancel all request where a token exists
    context.state.cancelTokens.forEach(request => {
      if (request.cancel) {
        request.cancel("cancelled");
      }
    });
    // Reset the cancelTokens store
    context.commit("CLEAR_CANCEL_TOKENS");
  }
};
